import { AppSidebar } from "@/components/app-sidebar";
import { ModuloDeImpressaoProvider } from "@/components/ModuloDeImpressaoComponent";

import { SiteHeader } from "@/components/site-header";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useImpressaoConfig } from "@/contexts/ImpressaoConfigContext";
import { useEffect, useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { alert } from "@/contexts/AlertModalContext";
import { Outlet } from "react-router";
import ChamadosWidget from "@/components/ChamadosWidget";
import SuporteBanner from "@/components/SuporteBanner";

function LayoutPrincipal() {
  const {
    impressaoConfig,
    verificarSeEstaProximoDeAcabarORolo,
    zerarEtiquetasImpressas,
  } = useImpressaoConfig();
  const [alertaRoloAcabando, setAlertaRoloAcabando] = useState(false);

  useEffect(() => {
    if (impressaoConfig) {
      if (verificarSeEstaProximoDeAcabarORolo()) {
        setAlertaRoloAcabando(true);
      }
    }
  }, [impressaoConfig]);
  return (
    <ModuloDeImpressaoProvider>
      <SidebarProvider
        style={
          {
            "--sidebar-width": "calc(var(--spacing) * 72)",
            "--header-height": "calc(var(--spacing) * 12)",
          } as React.CSSProperties
        }
      >
        <AppSidebar variant="inset" />
        <SidebarInset>
          <SiteHeader />
          {/* sessão aberta pelo suporte (handoff): visível em todas as telas */}
          <SuporteBanner />
          <div className="flex flex-1 flex-col">
            <div className="@container/main flex flex-1 flex-col gap-2">
              <AlertDialog
                open={alertaRoloAcabando}
                onOpenChange={setAlertaRoloAcabando}
              >
                <AlertDialogContent>
                  <AlertDialogHeader>
                    <AlertDialogTitle>Atenção</AlertDialogTitle>
                    <AlertDialogDescription>
                      O rolo de etiquetas está acabando. troque o rolo antes de
                      seguir com a impressão.
                    </AlertDialogDescription>
                  </AlertDialogHeader>
                  <AlertDialogFooter>
                    <AlertDialogAction
                      onClick={() => {
                        zerarEtiquetasImpressas();
                        setAlertaRoloAcabando(false);
                        if (!impressaoConfig?.app_id) {
                          alert.error(
                            "Defina um Hardware ID para ajustar o rolo.",
                          );
                          return;
                        }
                        window.open(
                          `https://ws-homolog.inovacode.app.br/v1/ajustar-rolo/${impressaoConfig?.app_id}/${impressaoConfig?._id}`,
                          "_blank",
                        );
                      }}
                    >
                      Confirmo que troquei o rolo
                    </AlertDialogAction>
                    <AlertDialogCancel>Ok</AlertDialogCancel>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialog>
              <Outlet />
            </div>
          </div>
          <ChamadosWidget />
        </SidebarInset>
      </SidebarProvider>
    </ModuloDeImpressaoProvider>
  );
}

export default LayoutPrincipal;
